import { PERFIS_DISPONIVEIS } from '../../../../components/modal/perfis-adicionais/PerfisAdicionais';
import { LogGeralItem, ROTULO_DO_TIPO_DE_ATOR } from '../../../../api/auditLogsApi';

/** `CHEFE_DE_OFICINA` → "Chefe de Oficina" — a mesma lista dos perfis, nunca uma cópia. */
export function rotuloDoPapel(papel: string): string {
  return PERFIS_DISPONIVEIS.find((p) => p.valor === papel || p.rotulo === papel)?.rotulo ?? papel;
}

/**
 * "Quem" por extenso: nome e papel para usuário; para os demais, o nome que o log guardou (a
 * integração, a rotina, a tentativa de login) com o tipo de ator ao lado — "SAAC (Integração)".
 */
export function descreverQuem(l: Pick<LogGeralItem, 'quem' | 'atorTipo' | 'atorPapel'>): string {
  if (l.atorTipo === 'USUARIO') return l.atorPapel ? `${l.quem} (${rotuloDoPapel(l.atorPapel)})` : l.quem;
  const tipo = ROTULO_DO_TIPO_DE_ATOR[l.atorTipo];
  return l.quem === tipo || l.quem.startsWith(tipo) ? l.quem : `${l.quem} (${tipo})`;
}

/** `2026-10-24T13:05:09.000Z` → `24/10/2026 10:05:09` no fuso de quem olha. */
export function formatarQuando(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const dois = (n: number) => String(n).padStart(2, '0');
  return `${dois(d.getDate())}/${dois(d.getMonth() + 1)}/${d.getFullYear()} ${dois(d.getHours())}:${dois(d.getMinutes())}:${dois(d.getSeconds())}`;
}
